import Tag from '@/components/Tag'

export type ISize = 'small' | 'middle' | 'large'

interface IProps {
  checked?: boolean
  color?: string
  size?: ISize
  round?: boolean // 是否圆角
  plain?: boolean // 是否是朴素标签
  bordered?: boolean // 是否有边框
  children?: React.ReactNode // 文字内容
  [key: string]: any
}

function SelectableTag(props: IProps) {
  const { checked, onClick, ...attrs } = props
  let { bordered, plain, color } = props
  if (!checked) {
    plain = true
    bordered = false
    color = '#030303'
  } else {
    plain = false
    bordered = true
  }

  function handleClick() {
    onClick(!checked)
  }

  return (
    <Tag { ...attrs } plain={ plain }
      bordered={ bordered } color={ color }
      onClick={ handleClick }></Tag>
  )
}

export default SelectableTag
